export default __webpack_public_path__ + "static/media/SaconFix.aca3e883.jpg";